import { render, staticRenderFns } from "./new-connection-pricing-rrp.vue?vue&type=template&id=5b4a9e58&scoped=true&"
import script from "./new-connection-pricing-rrp.vue?vue&type=script&lang=js&"
export * from "./new-connection-pricing-rrp.vue?vue&type=script&lang=js&"
import style0 from "./new-connection-pricing-rrp.vue?vue&type=style&index=0&id=5b4a9e58&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4a9e58",
  null
  
)

export default component.exports